import { Children, ReactNode, isValidElement, cloneElement } from "react";

interface StepsProps {
  children: ReactNode;
}

interface StepProps {
  title: string;
  children: ReactNode;
  _index?: number;
}

export function Steps({ children }: StepsProps) {
  const steps = Children.toArray(children).filter(isValidElement);
  return (
    <ol className="my-6 list-none p-0">
      {steps.map((child, i) =>
        isValidElement<StepProps>(child) ? cloneElement(child, { _index: i + 1 }) : child,
      )}
    </ol>
  );
}

export function Step({ title, children, _index }: StepProps) {
  return (
    <li className="relative pl-10 pb-8 last:pb-0 group">
      <div
        className="absolute left-3.5 top-7 bottom-0 w-px bg-border group-last:hidden"
        aria-hidden="true"
      />
      <div
        className="absolute left-0 top-0.5 w-7 h-7 rounded-full bg-primary-dim border border-primary-border flex items-center justify-center"
        aria-hidden="true"
      >
        <span className="text-xs font-medium text-primary-text">{_index}</span>
      </div>
      <h3 className="text-sm font-medium text-text mb-2 mt-0.5 pl-1">{title}</h3>
      <div className="docs-prose">{children}</div>
    </li>
  );
}
